import { useEffect, useState } from 'react';

// Shared mobile/compact detection. Mirrors SidebarShell's compact logic so the whole
// ecosystem agrees on what "mobile" means: narrow viewport, OR a coarse pointer only up to
// tablet width (1365px). Wide displays (>=1366px) are never treated as mobile, so touchscreen
// laptops and large touch monitors keep the docked desktop layout.
const query = (maxWidth) => `(max-width: ${maxWidth - 1}px), (max-width: 1365px) and (pointer: coarse)`;

export const useIsMobile = (maxWidth = 1024) => {
  const get = () =>
    typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query(maxWidth)).matches;
  const [mobile, setMobile] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(query(maxWidth));
    const onChange = () => setMobile(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, [maxWidth]);
  return mobile;
};

export default useIsMobile;
